import { EAccountRole } from 'types/GlobalAccount'

export enum UserTitle {
  CEO = 'CEO',
  CFO = 'CFO',
  IT = 'IT',
  LESSOR = 'LESSOR',
  TECHINCAL_MANAGER = 'TECHINCAL_MANAGER',
  REGION_MANAGER = 'REGION_MANAGER',
  FINANCE_CONTROLLER = 'FINANCE_CONTROLLER',
  CO_WORKER_TECHINCAL_MANAGEMENT = 'CO_WORKER_TECHINCAL_MANAGEMENT',
  MANAGEMENT_MANAGER = 'MANAGEMENT_MANAGER',
  CEO_ASSISTANT = 'CEO_ASSISTANT',
  LESSOR_MANAGER = 'LESSOR_MANAGER'
}

/** An account as GET /v1/internal/accounts returns it, for Homepal only. */
export interface InternalAccount {
  additional_information: {
    role: string | null
    preference: string | null
  }
  company_group_id: string | null
  created_at: string
  customer: {
    id: string
    name: string
    sso: boolean
    allow_key_metrics: boolean
  }
  email: string
  first_name: string | null
  full_name: string
  has_access_to_economy_settings: boolean
  allow_early_access_export_tables: boolean
  allow_access_to_analyses: boolean
  invite_accepted_at: string | null
  is_in_management_group: boolean
  last_seen_at: string | null
  last_name: string | null
  id: string
  role: EAccountRole
  title: UserTitle | null
}

/**
 * One NPS survey period of an account. A period ends with an answer or with
 * the third snooze.
 */
export interface InternalNpsPeriod {
  answer: {
    answered_at: string
    response: string | null
    score: number | null
  } | null
  snoozes: { snoozed_at: string; snooze_until: string }[]
}
